import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { useLayoutEffect } from "react";
import { Footer } from "../../../components/blog/footerBlog";
import { TopbarBlog } from "../../../components/blog/topbar";
import ContactSectionForm from "../../../components/ContactSectionForm";
import DeliveredResult from "../../../components/Products/DeliveredResult";
import HeroSection from "../../../components/Products/HeroSection";
import HowItWorksSection from "../../../components/Products/HowItWorksSection";
import ProductThemeWrapper from "../../../components/Products/ProductThemeWrapper";
import RpaToolsSection from "../../../components/Products/views/RPA/RpaToolsSection";
import WhyChooseSection from "../../../components/Products/WhyChooseSection";
import WhatsAppButton from "../../../components/WhatsAppButton";
import { size } from "../../../constants";
import { useTheme } from "../../../contexts/ThemeContext";

import { useWindowSize } from "../../../hooks/useWindowResize";
import {
	getI18nPaths,
	getI18nProps,
} from "../../../lib/next-i18next/getStatic";
import { FaceLiftGlobalStyle } from "../../../styles/theme";
import RpaSection from "../casos/views/RpaSection";
import { ProductMetadata } from "./product-metadata";

export default function ProdutoPage(data) {
	const router = useRouter();
	const { toggleTheme } = useTheme();

	useLayoutEffect(() => {
		toggleTheme("dark");
	}, [toggleTheme]);

	const { t } = useTranslation();

	const { slug } = router.query;

	const { width } = useWindowSize();
	const isMobile = width <= size.tablet;

	const variant = "purple";
	const deviceType = isMobile ? "mobile" : "laptop";

	const stepMobileImage = width < size.tablet ? "-mobile" : "";
	const steps = [
		{
			image: `/landings/assets/images/products/rpa/${data.product.locale}/00-rpa-cycle${stepMobileImage}.svg`,
			name: t(`products.rpa.steps.cycle.name`),
			text: t(`products.rpa.steps.cycle.text`),
		},
		{
			image: `/landings/assets/images/products/rpa/${data.product.locale}/01-rpa-identificacao${stepMobileImage}.svg`,
			name: t(`products.rpa.steps.identification.name`),
			text: t(`products.rpa.steps.identification.text`),
		},
		{
			image: `/landings/assets/images/products/rpa/${data.product.locale}/02-rpa-viabilidade${stepMobileImage}.svg`,
			name: t(`products.rpa.steps.feasibility.name`),
			text: t(`products.rpa.steps.feasibility.text`),
		},
		{
			image: `/landings/assets/images/products/rpa/${data.product.locale}/03-rpa-discovery${stepMobileImage}.svg`,
			name: t(`products.rpa.steps.discovery.name`),
			text: t(`products.rpa.steps.discovery.text`),
		},
		{
			image: `/landings/assets/images/products/rpa/${data.product.locale}/04-rpa-documentacao${stepMobileImage}.svg`,
			name: t(`products.rpa.steps.documentation.name`),
			text: t(`products.rpa.steps.documentation.text`),
		},
		{
			image: `/landings/assets/images/products/rpa/${data.product.locale}/05-rpa-validacao${stepMobileImage}.svg`,
			name: t(`products.rpa.steps.validation.name`),
			text: t(`products.rpa.steps.validation.text`),
		},
		{
			image: `/landings/assets/images/products/rpa/${data.product.locale}/06-rpa-desenvolvimento${stepMobileImage}.svg`,
			name: t(`products.rpa.steps.development.name`),
			text: t(`products.rpa.steps.development.text`),
		},
		{
			image: `/landings/assets/images/products/rpa/${data.product.locale}/07-rpa-integracao${stepMobileImage}.svg`,
			name: t(`products.rpa.steps.integration.name`),
			text: t(`products.rpa.steps.integration.text`),
		},
		{
			image: `/landings/assets/images/products/rpa/${data.product.locale}/08-rpa-producao${stepMobileImage}.svg`,
			name: t(`products.rpa.steps.production.name`),
			text: t(`products.rpa.steps.production.text`),
		},
		{
			image: `/landings/assets/images/products/rpa/${data.product.locale}/09-rpa-suporte${stepMobileImage}.svg`,
			name: t(`products.rpa.steps.support.name`),
			text: t(`products.rpa.steps.support.text`),
		},
		{
			image: `/landings/assets/images/products/rpa/${data.product.locale}/10-rpa-melhoria${stepMobileImage}.svg`,
			name: t(`products.rpa.steps.improvement.name`),
			text: t(`products.rpa.steps.improvement.text`),
		},
	];

	const results = [
		{
			value: t(`products.rpa.results.accuracy-value`),
			label: t(`products.rpa.results.accuracy`),
		},
		{
			value: t(`products.rpa.results.speed-value`),
			label: t(`products.rpa.results.speed`),
		},
		{
			value: t(`products.rpa.results.costs-value`),
			label: t(`products.rpa.results.costs`),
		},
		{
			value: t(`products.rpa.results.scalability-value`),
			label: t(`products.rpa.results.scalability`),
		},
	];

	const cards = [
		{
			number: "01",
			title: t(`products.rpa.cards.efficiency.title`),
			text: t(`products.rpa.cards.efficiency.text`),
		},
		{
			number: "02",
			title: t(`products.rpa.cards.quality.title`),
			text: t(`products.rpa.cards.quality.text`),
		},
		{
			number: "03",
			title: t(`products.rpa.cards.economy.title`),
			text: t(`products.rpa.cards.economy.text`),
		},
	];

	return (
		<ProductThemeWrapper variant={variant}>
			<ProductMetadata
				translations={data.translations}
				slug="rpa"
				imagePath="/landings/assets/images/products/rpa/rpa-robot-background.png"
			/>
			<TopbarBlog showTheme={false} isProduct />
			<FaceLiftGlobalStyle />
			<HeroSection
				title={t(`products.rpa.${deviceType}.hero.title`)}
				subtitle={t(`products.rpa.${deviceType}.hero.subtitle`)}
				highlight={t(`products.rpa.laptop.hero.description`)}
				videoSrc="/landings/assets/images/products/rpa/verzel-rpa-banner-animado-automatizacao-processos.mp4"
			/>

			<WhyChooseSection
				title={t(`products.rpa.${deviceType}.why-choose.title`)}
				description={t(`products.rpa.${deviceType}.why-choose.description`)}
				cards={cards}
				isMobile={isMobile}
			/>
			<HowItWorksSection
				steps={steps}
				title={t(`products.rpa.${deviceType}.how-it-works.title`)}
				description={t(`products.rpa.${deviceType}.how-it-works.description`)}
				isMobile={isMobile}
			/>

			<DeliveredResult
				theme="purple"
				backgroundImage="/landings/assets/images/products/rpa/rpa-resultados-automatizacao-performance-kpis-verzel.png"
				backgroundImageMobile="/landings/assets/images/products/rpa/rpa-resultados-automatizacao-performance-kpis-verzel-mobile.png"
				results={results}
				description={t(
					`products.rpa.${deviceType}.delivered-results.description`,
				)}
				title={t(`products.rpa.${deviceType}.delivered-results.title`)}
			/>

			{slug === "rpa" && <RpaToolsSection isMobile={isMobile} />}

			<RpaSection />
			<ContactSectionForm
				title={t(`products.rpa.contact.title`)}
				description={t(`products.rpa.contact.description`)}
				isMobile={isMobile}
			/>
			<WhatsAppButton />
			<Footer />
		</ProductThemeWrapper>
	);
}

export async function getStaticProps(ctx) {
	const locale = ctx.params?.locale || "pt";
	const i18nProps = await getI18nProps(ctx);
	const translations =
		i18nProps._nextI18Next.initialI18nStore[locale].translation;

	return {
		props: {
			...i18nProps,
			translations,
			product: {
				slug: "rpa",
				locale,
			},
		},
	};
}

export async function getStaticPaths() {
	const rpaPathsWithLocale = getI18nPaths([{ slug: "rpa" }]);

	return {
		paths: rpaPathsWithLocale,
		fallback: false,
	};
}
